import {
  Navigate,
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider
} from 'react-router-dom'

import RootLayout from './layouts/RootLayout';
import WorksLayout from './layouts/WorksLayout';
import Home from './pages/Home'
import Works from './pages/Works'
import WorkDetail from './pages/WorkDetail'
import About from './pages/About'
import SonoraAI from './pages/SonoraAI'
import Vloader from './pages/Vloader';
import Meriastro from './pages/Meriastro';
import PrivacyPolicy from './pages/SonoraAI/privacy_policy';
import DeleteAccountSonora from './pages/SonoraAI/delete_account';
import TermsAndConditions from './pages/SonoraAI/terms_and_conditions'
import EULA from './pages/SonoraAI/eula'
import EULAVloader from './pages/Vloader/eula_vloader'
import EULAMeriastro from './pages/Meriastro/eula_meriastro'
import TermsAndConditionsVloader from './pages/Vloader/terms_and_conditions_vloader'
import Error from './pages/Error';
import Faucet from './pages/Faucet'; // Faucet bileşenini içe aktar
import SharixDelete from './pages/SharixDelete';
import PrivacyPolicySharix from './pages/SonoraAI/privacy_policy_sharix';
import PrivacyPolicyVloader from './pages/Vloader/privacy_policy_vloader';
import PrivacyPolicyMeriastro from './pages/Meriastro/privacy_policy_meriastro';
import TermsAndConditionsMeriastro from './pages/Meriastro/terms_and_conditions_meriastro';
import AccountDeletionPage from './pages/Meriastro/account_delete';
import FalQuestions from './pages/Meriastro/fal_questions';
import Funo from './pages/Funo';
import RevoAI from './pages/RevoAI';

import PrivacyPolicyFuno from './pages/Funo/privacy_policy_funo';
import TermsAndConditionsFuno from './pages/Funo/terms_and_conditions_funo';
import EULAFunoAI from './pages/Funo/eula_funo';
import AccountDeletionPageFuno from './pages/Funo/account_delete';

import PrivacyPolicyRevoAI from './pages/RevoAI/privacy_policy_revoai';
import TermsAndConditionsRevoAI from './pages/RevoAI/terms_and_conditions_revoai';
import AccountDeletionPageRevoAI from './pages/RevoAI/account_delete';
import EULARevoAI from './pages/RevoAI/eula_revoai';

import DcpPanel from './pages/DcpPanel';
import AccountDeletionPageHealife from './pages/Healife/account_delete';

import TattooAI from './pages/TattooAI';
import TattooTestAccess from './pages/TattooAI/test_access';
import PrivacyPolicyTattooAI from './pages/TattooAI/privacy_policy_tattooai';
import TermsAndConditionsTattooAI from './pages/TattooAI/terms_and_conditions_tattooai';
import EULATattooAI from './pages/TattooAI/eula_tattooai';
import AccountDeletionPageTattooAI from './pages/TattooAI/account_delete';


// Eski /work/:name adresleri yeni Türkçe rotaya yönlenir (slug'lar korunur).
const LegacyWorkRedirect = () => {
  const name = window.location.pathname.split('/').pop();
  return <Navigate to={`/projeler/${name}`} replace />;
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path='/' element={<RootLayout />}>
        <Route index element={<Home />} />
        <Route
          path='projeler'
          element={<WorksLayout />}>
          <Route index element={<Works />} />
          <Route path=':name' element={<WorkDetail />} />
        </Route>
        <Route path='hakkimda' element={<About />} />
        {/* Eski İngilizce rotalar */}
        <Route path='work' element={<Navigate to='/projeler' replace />} />
        <Route path='work/:name' element={<LegacyWorkRedirect />} />
        <Route path='about' element={<Navigate to='/hakkimda' replace />} />
        <Route path='faucet' element={<Faucet />} />
        <Route path='sharix-delete-account' element={<SharixDelete />} />
        <Route path='sonora-ai' element={<SonoraAI />} />
        <Route path='sonora-ai/privacy-policy' element={<PrivacyPolicy />} />
        <Route path='sonora-ai/delete-account' element={<DeleteAccountSonora />} />
        <Route path='sharix-ai/privacy-policy' element={<PrivacyPolicySharix />} />
        <Route path='sonora-ai/terms-and-conditions' element={<TermsAndConditions />} />
        <Route path='sonora-ai/eula' element={<EULA />} />
        <Route path='vloader' element={<Vloader />} />
        <Route path='vloader/privacy-policy' element={<PrivacyPolicyVloader />} />
        <Route path='vloader/terms-and-conditions' element={<TermsAndConditionsVloader />} />
        <Route path='vloader/eula' element={<EULAVloader />} />
        <Route path='meriastro' element={<Meriastro />} />
        <Route path='meriastro/privacy-policy' element={<PrivacyPolicyMeriastro />} />
        <Route path='meriastro/terms-and-conditions' element={<TermsAndConditionsMeriastro />} />
        <Route path='meriastro/eula' element={<EULAMeriastro />} />
        <Route path='meriastro/account-delete' element={<AccountDeletionPage />} />
        <Route path='funo' element={<Funo />} />
        <Route path='funo/privacy-policy' element={<PrivacyPolicyFuno />} />
        <Route path='funo/terms-and-conditions' element={<TermsAndConditionsFuno />} />
        <Route path='funo/eula' element={<EULAFunoAI />} />
        <Route path='funo/account-delete' element={<AccountDeletionPageFuno />} />
        <Route path='revoai' element={<RevoAI />} />
        <Route path='revoai/privacy-policy' element={<PrivacyPolicyRevoAI />} />
        <Route path='revoai/terms-and-conditions' element={<TermsAndConditionsRevoAI />} />
        <Route path='revoai/eula' element={<EULARevoAI />} />
        <Route path='revoai/account-delete' element={<AccountDeletionPageRevoAI />} />
        <Route path='tattooai' element={<TattooAI />} />
        <Route path='tattooai/test-access' element={<TattooTestAccess />} />
        <Route path='tattooai/privacy-policy' element={<PrivacyPolicyTattooAI />} />
        <Route path='tattooai/terms-and-conditions' element={<TermsAndConditionsTattooAI />} />
        <Route path='tattooai/eula' element={<EULATattooAI />} />
        <Route path='tattoo-ai-delete-account' element={<AccountDeletionPageTattooAI />} />
        <Route path='healife/account-delete' element={<AccountDeletionPageHealife />} />
        <Route path='*' element={<Error />} />
      </Route>
      <Route path="meriastro/sana-ozel-fal" element={<FalQuestions />} />
      {/* Unlisted: Healife content admin. Access via the link's #k=<key> fragment. */}
      <Route path="dcp-panel-x7k2m9" element={<DcpPanel />} />
    </>
  )
)

function App() {
  return (
    <RouterProvider router={router} />
  );
}

export default App;
